import { SelfAssessment } from './self-assessment';

export class UpdateSelfAssessmentModel {
    selfAssessmentDetails: SelfAssessment;
    isAssessmentStatusEdited: boolean;
    isReviewStatusEdited: boolean;
    isOverallStatusEdited: boolean;
    isRuleConclusionEdited: boolean;
    isGapReviewStatusEdited: boolean;
    isGapActionStatusEdited: boolean;
    isEnhancementReviewStatusEdited: boolean;
    isEnhancementActionStatusEdited: boolean;

    constructor() {
        this.selfAssessmentDetails = new SelfAssessment();
        this.isAssessmentStatusEdited = false;
        this.isReviewStatusEdited = false;
        this.isOverallStatusEdited = false;
        this.isRuleConclusionEdited = false;
        this.isGapReviewStatusEdited = false;
        this.isGapActionStatusEdited = false;
        this.isEnhancementReviewStatusEdited = false;
        this.isEnhancementActionStatusEdited = false;
    }
}